import { Injectable } from '@angular/core';
import { Inputfiledsbase } from '../../../../models/inputfiledsbase';
import { TextboxQuestion } from '../../../../question-textbox';
import { of } from 'rxjs';
import { TextareaQuestion } from '../../../../question-textarea';

@Injectable({
  providedIn: 'root',
})
export class PageNameService {
  constructor() {}

  getpagesNameform() {
    const questions: Inputfiledsbase<string>[] = [
      new TextboxQuestion({
        key: 'name',
        label: 'Page Name',
        required: true,
        order: 1,
      }),
      new TextareaQuestion({
        key: 'description',
        label: 'Description',
        required: true,
        order: 2,
      }),
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }
}
